import React, { useState, useEffect, useCallback, useRef } from "react";
import "aframe";
import { useTranslation } from "react-i18next";

const CustomVrPlayer = ({
  id,
  src,
  poster,
  height,
  width,
  media,
  gyroscope,
  pause,
}) => {
  const { t } = useTranslation();

  const [clickStartingPosition, setClickStartingPosition] = useState({ x: 0, y: 0 });
  const [rot] = useState(180);

  const clickStartingPositionRef = useRef(clickStartingPosition);
  clickStartingPositionRef.current = clickStartingPosition;

  const handleClick = useCallback((e) => {
    setClickStartingPosition({ x: e.x, y: e.y });
  }, []);

  const handleClickLeave = useCallback(
    (e) => {
      let newPosition = { x: e.x, y: e.y };
      if (
        clickStartingPositionRef.current.x === newPosition.x &&
        clickStartingPositionRef.current.y === newPosition.y
      ) {
        pause();
      }
    },
    [pause],
  );

  const handleTouchStart = useCallback((e) => {
    setClickStartingPosition({
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
    });
  }, []);

  const handleTouchEnd = useCallback(
    (e) => {
      let newPosition = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY,
      };
      if (
        clickStartingPositionRef.current.x === newPosition.x &&
        clickStartingPositionRef.current.y === newPosition.y
      ) {
        pause();
      }
    },
    [pause],
  );

  useEffect(() => {
    var scene = document
      .getElementById(id + "-vr-scene")
      .querySelector("canvas");
    scene.id = id + "-vr-canva";
    scene.addEventListener("mousedown", handleClick);
    scene.addEventListener("mouseup", handleClickLeave);
    scene.addEventListener("touchstart", handleTouchStart);
    scene.addEventListener("touchleave", handleTouchEnd);

    return () => {
      var sceneEl = document
        .getElementById(id + "-vr-scene")
        ?.querySelector("canvas");
      if (sceneEl) {
        sceneEl.removeEventListener("mousedown", handleClick);
        sceneEl.removeEventListener("mouseup", handleClickLeave);
        sceneEl.removeEventListener("touchstart", handleTouchStart);
        sceneEl.removeEventListener("touchleave", handleTouchEnd);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <span id={id + "-vr-scene"}>
      {/* <button
        style={{ width: "200%" }}
        onClick={() => {
          testG();
        }}
      >
        TEST GYROSCOPIC SENSOR
      </button> */}
      <a-scene
        // always-fullscreen="platform:nu; debug:true"
        allowfullscreen="no"
        vr-mode-ui="enabled: true"
        device-orientation-permission-ui={`enabled: ${
          gyroscope
        };denyButtonText:${t(
          "post.vrDeny",
        )};allowButtonText:${t(
          "post.vrAllow",
        )};cancelButtonText:${t(
          "post.vrCancel",
        )};deviceMotionMessage:${t(
          "post.vrDeviceMotion",
        )};httpsMessage:${t("post.vrHttpsMessage")}`}
        enabled="true"
        denyButtonText="Denny"
        allowButtonText="Almight"
        cancelButtonText="Canc"
        deviceMotionMessage="DevMotMes"
        mobileDesktopMessage="MOBILEDESKMEG"
        httpsMessage="SWICTHHTHTHHT"
        https-message="messsss"
        light="defaultLightsEnabled: false"
        height={height}
        width={width}
        embedded
      >
        {/* <a-dialog-text>CIAO</a-dialog-text> */}
        <a-entity light="type: ambient; color: #fff"></a-entity>
        <a-assets height={height} width={width}>
          <video
            poster={poster}
            id={id}
            src={src}
            crossOrigin="anonymous"
            controls={false}
            height={height}
            width={width}
          />
        </a-assets>

        {media.projectionType === 1 && (
          <>
            <a-plane
              position={"0 0 1"}
              height="100"
              width="100"
              rotation="0 180 0"
              color="black"
            ></a-plane>{" "}
            <a-videosphere
              src={"#" + id}
              rotation={`0 ${rot} 0`}
              id={id + "-vr-sphere"}
            ></a-videosphere>
          </>
        )}
        {media.projectionType === 2 && (
          <>
            <a-plane
              position={"0 0 1"}
              height="100"
              width="100"
              rotation="0 180 0"
              color="black"
            ></a-plane>
            <a-videosphere
              // src={"#" + id}
              rotation={`0 ${rot} 0`}
              id={id + "-vr-sphere"}
              // material={`src: ${id}`}
              material={`src: #${id} ; repeat: 2 1`}
            ></a-videosphere>
          </>
        )}
        {media.projectionType === 3 && (
          <a-videosphere
            src={"#" + id}
            rotation={`0 ${rot} 0`}
            id={id + "-vr-sphere"}
          ></a-videosphere>
        )}
        {media.projectionType === 4 && (
          <>
            <a-plane
              position={"0 4 -2.5"}
              height="10"
              width="15"
              rotation="0 0 0"
              material={`src: #${id}`}
              id={id + "-vr-plane-1"}
            ></a-plane>
            <a-plane
              position={"-2.5 -1 0"}
              height="10"
              width="15"
              rotation="0 90 0"
              material={`src: #${id}`}
              id={id + "-vr-plane-2"}
            ></a-plane>
            <a-plane
              position={"5 4 2.5"}
              height="10"
              width="15"
              rotation="0 180 0"
              material={`src: #${id}`}
              id={id + "-vr-plane-3"}
            ></a-plane>

            <a-plane
              position={"2.5 -1 5"}
              height="10"
              width="15"
              rotation="0 270 0"
              material={`src: #${id}`}
              id={id + "-vr-plane-4"}
            ></a-plane>
            <a-plane
              position={"-5 4 -2.5"}
              height="10"
              width="15"
              rotation="90 0 0"
              material={`src: #${id}`}
              id={id + "-vr-plane-5"}
            ></a-plane>
            <a-plane
              position={"5 -1 -2.5"}
              height="10"
              width="15"
              rotation="-90 0 0"
              material={`src: #${id}`}
              id={id + "-vr-plane-6"}
            ></a-plane>
          </>
        )}
        {media.projectionType === 5 && (
          <>
            <a-plane
              position={"-2.5 1.5 -2.5"}
              height="10"
              width="15"
              rotation="0 0 90"
              material={`src: #${id}`}
              id={id + "-vr-plane-1"}
              //non si tocca
            ></a-plane>
            <a-plane
              position={"-2.5 -1 5"}
              height="10"
              width="15"
              rotation="0 90 0"
              material={`src: #${id}`}
              id={id + "-vr-plane-2"}
            ></a-plane>
            <a-plane
              position={"0 -1 2.5"}
              height="10"
              width="15"
              rotation="0 180 0"
              material={`src: #${id}`}
              id={id + "-vr-plane-3"}
              //non si tocca
            ></a-plane>

            <a-plane
              position={"2.5 -1 5"}
              height="10"
              width="15"
              rotation="0 270 0"
              material={`src: #${id}`}
              id={id + "-vr-plane-4"}
            ></a-plane>
            <a-plane
              position={"-2.5 4 -5"}
              height="10"
              width="15"
              rotation="90 0 90"
              material={`src: #${id}`}
              id={id + "-vr-plane-5"}
            ></a-plane>
            <a-plane
              position={"-2.5 -1 -5"}
              height="10"
              width="15"
              rotation="-90 0 90"
              material={`src: #${id}`}
              id={id + "-vr-plane-6"}
            ></a-plane>
          </>
        )}
        <a-camera
          // look-controls-enabled="false" disable rotation of the camera(possible use for a custom movement)
          // position="0 0 0"
          wasd-controls-enabled="false"
          id={id + "-vr-camera"}
        ></a-camera>
      </a-scene>
    </span>
  );
};

export default CustomVrPlayer;
